<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-import"
      scrollable
      centered
      title="Adicionar anexo"
      button-size="sm"
    >
      <div class="form-group row">
        <div class="col-md-12 pt-2">
          <label for="txtData"> Anexo:</label>
          <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="*"
                @change="onFileChange"
              />
              <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique ou arraste aqui para anexar!</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
          <p style="text-align: center; margin-top: 0.5em;" class="text-danger">Tamanho máximo por envio: 20mb.</p>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onCreate" v-b-tooltip.hover :title="'Importar'"><i class="fas fa-check-circle"></i><span class="d-md-down-none"> Importar</span></button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import AttachmentRepository from '@/shared/http/repositories/configurations/attachment.js'

export default {
  name: 'AttachmentModal',
  mixins: [ActionsForm],
  data () {
    return {
      attach: null,
      files: [],
      uploadedSizeCapInBytes: 20480000, // 20mb
      uploadedAcceptableFormats: [
        // Documentos
        'pdf', 'txt', 'docx', 'odt', 'md',
        // Planilhas
        'xlsx', 'ods', 'csv',
        // Apresentações
        'pptx', 'odp',
        // Imagens
        'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'tif', 'ico',
        // Multimídia
        'mp4', 'webm', 'mov', 'avi', 'mp3', 'wav', 'ogg',
        // Dados
        'eml', 'msg', 'ics', 'vcf'
      ]
    }
  },
  methods: {
    showModal () {
      this.onClear()
      this.$refs['modal-import'].show()
    },
    hideModal () {
      this.$refs['modal-import'].hide()
    },
    onClear () {
      this.attach = null
      this.files = []
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onUploadDrop (event) {
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    /**
     * Validates if uploaded file's format is acceptable. Returns: bool.
     * @param file file object
     * @param acceptableFormatsArray array[string]
     */
    isValidFormat (file, acceptableFormatsArray) {
      if (file.name.indexOf('.') !== -1) {
        let fileExtArray = file.name.split('.')
        let fileExt = fileExtArray.pop().toLowerCase()
        return acceptableFormatsArray.includes(fileExt)
      } else {
        return false
      }
    },
    /**
     * Validates if uploaded file's size in bytes is acceptable. Returns: bool.
     * @param file file object
     * @param sizeCapInBytes Integer number
     */
    isValidSize (file, sizeCapInBytes) {
      return file.size <= sizeCapInBytes
    },
    onCreate () {
      loading.push()

      var formData = new FormData()
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          let validSize = this.isValidSize(file, this.uploadedSizeCapInBytes)
          let validFormat = this.isValidFormat(file, this.uploadedAcceptableFormats)
          if (!validSize || !validFormat) {
            this.onExceptionRenderMessageOnToaster('<strong>Erro</strong><br>Arquivo inválido devido a tamanho ou tipo.')
            return
          }
          formData.append('file', file)
        }
      }

      AttachmentRepository.Create(formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.onClear()
            this.hideModal()
            this.$emit('Back')
            loading.pop()
          }
        })
        .catch(this.onExceptionWithErrorMessage)
    }
  }
}
</script>

<style scoped>
  .upload {
    border: solid 1px #ccc;
    border-radius: 4px;
    background-color: #efefef;
    padding: 3%;
    width: 100%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/attachments/components/modal/importmodal.vue